import React, { useState, useEffect } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import get from "lodash/get";
import { string } from "prop-types";

import "./gdprPolicy.m.css";

const GdprPolicy = ({ domainLink, pageType }) => {
  const [showGdpr, setShowGdpr] = useState(false);
  useEffect(() => {
    if (pageType !== "home-preview" && pageType !== "story-preview" && pageType !== "story-public-preview-page") {
      setShowGdpr(true);
    }
  }, [pageType]);

  if (getCookieConsentValue()) {
    const cookies = new Cookies();
    cookies.set("CookieConsent", true, { path: "/", maxAge: 60 * 60 * 24 * 365 });
  }
  return showGdpr ? (
    <div>
      <CookieConsent
        location="bottom"
        buttonText="ঠিক আছে"
        containerClasses="gdpr-wrapper"
        style={{
          background: "#001246",
          fontSize: "14px",
          padding: "8px",
          fontFamily: "Shurjo",
          display: "grid",
          gridAutoFlow: "column",
          justifyContent: "center",
        }}
        buttonWrapperClasses="ok-button-link"
        buttonStyle={{ 
          background: "#0099ff",
          color: "#fff",
          fontSize: "14px",
          borderRadius: "3px",
          padding: "3px 8px",
          margin: "0 0 0 12px",
        }}
        contentStyle={{ margin: "auto" }}
      >
        এই ওয়েবসাইট ব্যবহার করার মধ্য দিয়ে আপনি আমাদের <a href={`${domainLink}/privacy-policy`} rel="noreferrer" target="_blank" style={{ textDecoration: "underline", color: "#fff" }}>গোপনীয়তা নীতি</a> তে সম্মতি দিয়েছেন
        
      </CookieConsent>
    </div>
  ) : null
  
};

GdprPolicy.propTypes = {
  domainLink: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  domainLink: get(state, ["qt", "currentHostUrl"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
});

export default connect(mapStateToProps, "")(GdprPolicy);
